import { image } from "framer-motion/client";

export const Bio = {
  name: "Vikram Solanki",
  roles: [
    "Data Scientist",
    "Full Stack Developer",
    "Machine Learning Engineer",
    "Android Developer",
    "Programmer",
  ],
  description:
    "I’m an Artificial Intelligence and Data Science Engineer with a strong foundation in Data Structures and Algorithms. Passionate about building intelligent solutions, I specialize in web and Android development. I enjoy solving real-world problems through data-driven insights and scalable, efficient code.",
  github: "https://github.com/Vikramsolanki12",
  resume:
    "https://drive.google.com/file/d/150E8YcJFlP3HF7hJedE1CLYFr1z5GMwA/view",
  linkedin: "https://www.linkedin.com/in/vikram-solanki12",
  twitter: "https://twitter.com/Solanki_1209",
  insta: "https://www.instagram.com/vikram_solank1/",
};

export const skills = [
  {
    title: "Data Science",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "SQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "NumPy",
        image:
          "https://images.seeklogo.com/logo-png/39/1/numpy-logo-png_seeklogo-398690.png",
      },
      {
        name: "Pandas",
        image:
          "https://images.seeklogo.com/logo-png/48/1/pandas-icon-logo-png_seeklogo-483545.png",
      },
      {
        name: "Matplotlib",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Created_with_Matplotlib-logo.svg/2048px-Created_with_Matplotlib-logo.svg.png",
      },
      {
        name: "Plotly",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQSSkZvKzlIRJVwFNMN8PAJif0oYRuziGiPdA&s",
      },
      {
        name: "Seaborn",
        image: "https://cdn.worldvectorlogo.com/logos/seaborn-1.svg",
      },
      {
        name: "Tableau",
        image:
          "https://logos-world.net/wp-content/uploads/2021/10/Tableau-Symbol.png",
      },
      {
        name: "Excel",
        image:
          "https://static.vecteezy.com/system/resources/previews/049/116/742/non_2x/microsoft-excel-icon-transparent-background-free-png.png",
      },
      {
        name: "Google sheets",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Google_Sheets_logo_%282014-2020%29.svg/1498px-Google_Sheets_logo_%282014-2020%29.svg.png",
      },
    ],
  },

  {
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Tenserflow",
        image:
          "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEj1WtoTMC1zbpYYgxBlVKZx7MhSkc1V3Ks2kH7Fo3Ltoj6bQM6YaP7o7TsTt7uHtBnbzaNupF3k4Jx9uYPjZR3R2zSd66xx8nzq4HxLbXxPLxxw_rlM8QAhY4bKiPWmMotb8v9-1iBSQjqKVGeDUC229b0jgnZBLMXbQvMU8GWTbYepDt9YzY2ox6irl8w/s1600/images%20(1).png",
      },
      {
        name: "Keras",
        image:
          "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjsNPL1esRcEe6oszZnnEoS0z_qgx_PwPcGgkhN8zij0Bir5svtHRPlzkpofBWlloofCM-k7sAD24UArHFtcIWnVI3B0ozRpdMh89JB_s72vH2SuYP_UyQYMi1O0Upjoo9jqiT-r1yRvuXfyNt9Mz9uHQC41BEm51jPm1xnLmD0mDldPJHw1dRAbphtdh0/s320/1200px-Keras_logo.svg.png",
      },
      {
        name: "Sk Learn Kit",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
      },
      {
        name: "PyTorch",
        image:
          "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhabVmjx0UTKLDBRI-hnX4LGNOmmg6K0E_ZE0ebaA9IsP9RF-pgty7SSKUX0_LihODPJuEz4HFzL5A-9TDTyC91I_L-m2Z5FYBArHnOb4gWyqvptQWHk1d1U13E3MIwBRlD0EI8XmhqcVKtca8frA1oejWi9Ev9kSbQUQi-lu0z4eQqMsXSP6N_6J6qKEA/s320/pytorch-logo-1.png",
      },
      {
        name: "Jupyter",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },
      {
        name: "Google Colab",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/d/d0/Google_Colaboratory_SVG_Logo.svg",
      },
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Tailwind",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/2560px-Tailwind_CSS_Logo.svg.png",
      },
      {
        name: "Three.js",
        image:
          "https://canada1.discourse-cdn.com/flex035/uploads/threejs/optimized/2X/e/e4f86d2200d2d35c30f7b1494e96b9595ebc2751_2_1016x1024.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },

  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "React Native",
        image:
          "https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
      {
        name: "Adobe Photoshop",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Adobe_Photoshop_CC_icon.svg/1051px-Adobe_Photoshop_CC_icon.svg.png",
      },
      {
        name: "Davinci Resolve",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/DaVinci_Resolve_Studio.png/500px-DaVinci_Resolve_Studio.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi13rekyJZHpPNAFbBeg3LUD__fISYWrf4mUHVgYamobQjf7vJ4ZrWUTJN_vKKY0HX63jfv_sYObOSpN4sL6v3j8QSuHSrxB1HsFBpacibc-tTQNKKHFeiqHLSaaqXIHLvzQVRhZMEQkWNsJ7nL6jSX1NtISAFyAx2hXDJJfnMUqNJLjDVxUl1StYft6bM/s623/logo.png",
    role: "Data Science Intern",
    company: "My Job Grow",
    date: "Nov 2024 - Dec 2024",
    desc: "I completed a hands-on internship that immersed me in real-world data science applications. During this period, I:🔄 Wrangled and Preprocessed Data using Python libraries like Pandas and NumPy, 📈 Visualized Data Insights with Matplotlib, Seaborn, and Plotly,🔍 Conducted Exploratory Data Analysis (EDA) to extract trends and patterns,🤖 Built and tested basic Machine Learning models using Scikit-learn,🚀 Worked on real-life projects, simulating industry problems and delivering end-to-end solutions",
    skills: [
      "Python",
      "NumPy",
      "Pandas",
      "Matplotlib",
      "seaborn",
      "Sckit-learn",
      "Tensorflow",
      "SciPy",
    ],
    doc: "",
  },
  {
    id: 1,
    img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjdNAdFx0ne_srf8BeZlpYq_QNs3_jItfVmJ-Cqk_0brx21Xgdn8joJN2C8H4jxWIuSOYqS_sPoXVAf6a4yzYvhy-vRIr21-4csO_KnNlTboAWV6UdVKyrPV2H-p5HUF8FwU2iWYBCUKYIMydtoUL7zCvoqzO1ri4JrumGbO5UaZfR-lWbPdE3doFTEQtY/s320/roboai-hub-ratanada-jodhpur-institutes-for-advanced-space-science-vizfc9f5h6-250.jpg",
    role: "Robotics Intern",
    company: "ROBOAI HUB",
    date: "June 2025 - Aug 2025",
    desc: "I gained hands-on experience at the intersection of robotics, artificial intelligence, and embedded systems. During my internship, I: 🛠️ Worked on robotic control systems using microcontrollers like Arduino and Raspberry Pi ; 🤖 Developed and programmed autonomous robotic tasks using sensors and actuators ; 🌐 Integrated AI models for object detection, path tracking, and automation ; 💻 Utilized Python, OpenCV, and basic ROS (Robot Operating System) concepts ; 📊 Participated in building real-time robotic prototypes that simulated real-world use cases",
    skills: [
      "Robotics",
      "Artificial Intelligence",
      "OpenCV",
      "Robot Programming",
      "Arduino",
    ],
    doc: "",
  },
  {
    id: 2,
    img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg00IPOw6Vfk1oswzMqik587ejg8fMPi_a4A4-Bb3ugqeS6sQrXvkaW30U2pXxKnfcYLH2Uf-dbG9Em5ZWC5mcN97c5rsuh6DPhNeRtUAZO_nFkO3AL6utypjVA7lsnkPwmvUJ-SUFYrBu0D5P3tSjyxW_defpX4K9FeTbc_u4qvDeS-mMJzAau24FA2Lk/s320/Defence_Research_and_Development_Organisation.svg.png",
    role: "Research Intern",
    company: "Defence Laboratory - Jodhpur (DRDO)",
    date: "June 2025 - July 2025",
    desc: "As a Research Intern at the prestigious Defence Research and Development Organisation (DRDO) – Defence Laboratory Jodhpur, I explored advanced applications of Machine Learning (ML) and Deep Learning (DL) in defense-oriented technologies. My key contributions included: 🧠 Conducted in-depth research and analysis on modern ML/DL algorithms for pattern recognition, classification, and prediction tasks ; 📊 Worked with Python, TensorFlow, and scikit-learn for implementing and testing model performance ; 🛡️ Investigated the applicability of AI techniques in autonomous systems, surveillance, and threat detection ; 🧪 Collaborated with senior scientists on real-world defense datasets and presented technical findings in weekly review meetings",
    skills: [
      "NumPy",
      "Pandas",
      "Matplotlib",
      "Seaborn",
      "TensorFlow",
      "Scikit-learn",
      "Pytorch",
    ],
    doc: "",
  },
];

export const education = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/en/thumb/f/f7/M.B.M._Engineering_College_-_Logo.png/250px-M.B.M._Engineering_College_-_Logo.png",
    school: "M.B.M. University , Jodhpur",
    date: "Sep 2023 - current",
    grade: "8.74 CGPA (Till 3rd Sem)",
    desc: "I am currently pursuing a Bachelor's degree in Artificial Intelligence and Data Science at M.B.M. University, Jodhpur. I have completed 4 semesters and have a CGPA of 9.32. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of Institute Innovation Council, M.B.M. University, where I am learning and working with experienced team.",
    degree:
      "Bachelor of Engineering - B.E., Artificial Intelligence and Data Science",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_E5o9w4scM4NSHZALzCc4hyPLhd4RFz5Anw&s",
    school: "Mayur Nobles Academy, Barmer",
    date: "June 2021 - April 2022",
    grade: "96.40%",
    desc: "I completed my class 12 high school education at Mayur Nobles Academy, Barmer, where I studied Science with Mathematics.",
    degree: "RBSE(XII), Science with Mathematics",
  },
  {
    id: 2,
    img: "https://i.pinimg.com/474x/54/06/50/5406500b5f81f7e820174c0350a3c151.jpg",
    school: "Shree Jasnath Edu. Aca.,Barmer",
    date: "June 2019 - April 2020",
    grade: "96.33%",
    desc: "I completed my class 10 education at Shree Jasnath Education Academy, Barmer where I studied RBSE syllabus.",
    degree: "RBSE(X)",
  },
];

export const volunteer = [
  {
    id: 0,
    img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhZdJjgfzl1gArFM26xZdWGi1C9YfFbGTetwr0Hf8cdnxGVL5QWTVTxh_a5XaTWadZKnxvfHW1ZKF8CVjr5iYu36Ba4K9XyV4r6zpHytckmzhdbltI5N-ebyrZQw_KTP9W8pDVCJ4sFX54NTJJucY-i-GCW5FKJVqJ7yccFZy9gR2O66ua2lGk9vCVJXuI/s320/IIC-logo.jpeg",
    role: "Innovation Ambassador - Data Handling",
    company: "Institute Innovation Council - MBM University",
    date: "Sep 2024 - current",
    desc: "As the Data Handling Point of Contact (PoC), I played a pivotal role in managing, analyzing, and organizing institutional innovation data to support decision-making and strategic initiatives. I collaborated with council members to ensure accurate documentation of events, project progress, and performance metrics. Leveraging my skills in data science and visualization, I helped transform raw data into actionable insights and reports, enhancing transparency and engagement across the university's innovation ecosystem.",
    skills: [
      "Canva",
      "Excel",
      "Graphics Designing",
      "Data collection",
      "organizing skills",
    ],
  },
  {
    id: 1,
    img: "https://www.pngkey.com/png/full/247-2479287_nss-logo-national-service-scheme-logo-png.png",
    role: "Student Volunteer",
    company: "National Service Scheme",
    date: "Sep 2023 - current",
    desc: "As a student volunteer in the National Service Scheme (NSS) at my university, I actively contributed to various community outreach and social welfare initiatives. My responsibilities included organizing and participating in cleanliness drives, awareness campaigns, health check-up camps, and tree plantation programs. This role allowed me to develop a strong sense of social responsibility, teamwork, and leadership while making a positive impact on the local community.",
    skills: [
      "Leadership",
      "Teamwork and Collaboration",
      "Problem-Solving",
      "Time Management",
    ],
  },
];

export const certificates = [
  {
    id: 0,
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRIcml3nEHHjOqhoZHkxUGOZxKbJwcBiEHfuA&s",
    name: "Redhat Certified System Administrator(RHCSA)",
    company: "RedHat",
    skills: ["linux", "System Administration", "RHEL"],
    link: "https://www.credly.com/badges/5069de48-8673-4bc4-9885-7b5fcfdb2f55/linked_in_profile",
  },
  {
    id: 1,
    logo: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi13rekyJZHpPNAFbBeg3LUD__fISYWrf4mUHVgYamobQjf7vJ4ZrWUTJN_vKKY0HX63jfv_sYObOSpN4sL6v3j8QSuHSrxB1HsFBpacibc-tTQNKKHFeiqHLSaaqXIHLvzQVRhZMEQkWNsJ7nL6jSX1NtISAFyAx2hXDJJfnMUqNJLjDVxUl1StYft6bM/s623/logo.png",
    name: "Data Science & Machine Learning",
    company: "My Job Grow",
    skills: [
      "Data Science",
      "Machine Learning",
      "Deep Learning",
      "Natural Language Processing(NLP)",
    ],
    link: "https://drive.google.com/file/d/12nFrF9EVCqbr2kl2bN912dKabvvIRz4O/view",
  },
  {
    id: 2,
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/2048px-Google_%22G%22_logo.svg.png",
    name: "Google Data Analytics Professional Certificate",
    company: "Coursera",
    skills: ["Data Cleanup", "Data Analysis", "Data Visualization"],
    link: "https://drive.google.com/file/d/1UCQXmiRKGScFl3NE-Z4u_AZ4W14VmS-o/view",
  },
  {
    id: 3,
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/2048px-Google_%22G%22_logo.svg.png",
    name: "Google Cybersecurity",
    company: "Coursera",
    skills: [
      "CyberSecurity",
      "Security Tools",
      "Linux",
      "SQL",
      "CyberSecurity with Python",
    ],
    link: "https://drive.google.com/file/d/1eDQ_SfixWKmp20pU9sVNV-_rp0dadNS7/view",
  },
  {
    id: 4,
    logo: "https://upload.wikimedia.org/wikipedia/commons/e/eb/GeeksForGeeks_logo.png",
    name: "Data Science Bootcamp",
    company: "GeeksforGeeks",
    skills: [
      "Python",
      "Numpy",
      "Pandas",
      "Matplotlib",
      "Seaborn",
      "Machine Learning",
    ],
    link: "https://drive.google.com/file/d/1mO5_ASWsImLyV12Q13nPttu8PDyY8ZlF/view",
  },
  {
    id: 5,
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Tata_logo.svg/1116px-Tata_logo.svg.png",
    name: "Data Visualisation: Empowering Business with Effective Insights",
    company: "Forage",
    skills: ["Python", "Data Visualisation", "Tableu", "Data Analysis"],
    link: "https://drive.google.com/file/d/183RH52U7Ys2SbMi42Uw29rfeMKbvLqqY/view",
  },
  {
    id: 6,
    logo: "https://pythoninstitute.org/assets/651eb5342fb67369437591.png",
    name: "OpenEDG Python Institute : Programming with Python Professional Certificate",
    company: "Python Institute",
    skills: ["Python", "Object Oriented Programming(Oops)"],
    link: "https://www.linkedin.com/learning/certificates/1feb1ddc647e642f3180110eb70182b30e6344ef813f990d9764faa3c72552db",
  },
];

export const projects = [
  {
    id: 0,
    title: "Tic Tac Toe",
    date: "Aug 2024",
    description:
      "This project is a classic Tic Tac Toe game developed using Python and the Tkinter library for the graphical user interface. It offers a simple two-player gameplay experience on the same machine with a clean and interactive GUI.The project showcases my ability to implement game logic, GUI design, and event-driven programming using Python.",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgGsb9RG-e3MUUejGq2lDUJPipb1WEvVCNYuohOHOFuvPaCPuECCbTVKHRIgNrbf19FimaA_SFkJLg-aoCOmDrbGc3hWMI8I7TI9QJzK2l7KAJ6GKJYa0u-uidEGfk_czHGO2DFH6n4EfwgqeFf9rp6AoAAXc5FaqQUxA2_p2p9Sh7S-qN3Z24Ci7zDuR4/s320/ezgif.com-animated-gif-maker.gif",
    tags: ["Python", "Tkinter", "Desktop GUI", "Game"],
    category: ["desktop GUI"],
    github: "https://github.com/Vikramsolanki12",
  },
  {
    id: 1,
    title: "Basic Calculator",
    date: "Aug 2024",
    description:
      "This project is a basic calculator application built using Python and its built-in Tkinter library for creating the graphical user interface. It demonstrates my understanding of GUI development in Python and the implementation of event-driven programming concepts.The calculator supports core arithmetic operations and provides a clean, responsive user interface suitable for desktop usage.",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiUiB7yIIjs-9QDMABKlXZPMMtUutsUCbQXydc6YMhNbJburIaYctcFs35845wx8JxlEOElEvSCZXvrs3O9Ki7vZ-rvvkq7hRAdLD1vuvBm0oA4mwz1i32SRIx6Jv0yyH_pBZoWInc7h92eEBSD44SBhkFUyICBy4Ecrx2FvI83vrarHwWpzbtSldMO1Aw/s320/ScreenRecording2025-06-29at12.49.33PM-ezgif.com-video-to-gif-converter.gif",
    tags: ["Python 3", "Tkinter"],
    category: ["desktop GUI"],
    github: "https://github.com/Vikramsolanki12/calculator.py.git",
  },
  {
    id: 2,
    title: "Student Result Management System",
    date: "Oct 2024",
    description:
      "Student Result Management System is a desktop application built with Python’s Tkinter library and a local database (SQLite/MySQL). It enables institutions to efficiently manage student records with a clean GUI. Key features include CRUD operations, result entry, GPA calculation, and offline data storage, making it ideal for use in schools or colleges without internet dependency.",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhIB_jR9drU-Mlge5mVa7ddHEKOLM1Ojrd61VGrAcfbyxONXGaDYnfs3aLx3i7XBlLIVRYTrQHc6smJf8xOGYUP0cF-_m5nN2UQED8L7XEOO5ogufMm2IG9ahse_xNUfjsrSWfujX2aWYBW1HDpU0NEtnpxS8ncLoFYyx-753AmMzxfCjFyhCXPiyFyoLc/s320/Screenshot%202025-06-20%20at%2010.27.39%E2%80%AFAM.png",
    tags: ["tkinter", "Python 3", "MySQL", "OOP", "Modular File Structure"],
    category: ["desktop GUI"],
    github: "https://github.com/Vikramsolanki12",
  },
  {
    id: 3,
    title: "Quiz App",
    date: "Dec 2024 - Jan 2025",
    description:
      "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
    image:
      "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
    tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
    category: ["android app"],
    github: "https://github.com/Vikramsolanki12",
    webapp: "https://github.com/Vikramsolanki12",
  },
  {
    id: 4,
    title: "Whatsapp Clone",
    date: "Jan 2025",
    description:
      "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
    tags: ["React Js", "Firebase", "Firestore", "Node JS"],
    category: ["web app"],
    github: "https://github.com/Vikramsolanki12",
    webapp: "https://github.com/Vikramsolanki12",
  },
  {
    id: 5,
    title: "Face Recognition",
    date: "Jan 2025",
    description:
      "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjzCzqGHB4XpA8ii3Ywj-LsWYUgW5zsSy8NyKAlMGNWVNEAA68w-iiMFlPFd2-6ZXgqXRUmnZIedf1Z7QpaHx-BArYNbUEpvmkI2LPXEFKePxCA7PUA4PD-eYNNZD1Dioaeg75BmNApHyuAAyI-eyDGVK4A-3EKISQnCDhXyNf4ckL4UprMzMUZkahE7aM/s1600/images.jpeg",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: ["AI & ML"],
    github: "https://github.com/Vikramsolanki12/face_recognition_system.git",
    webapp: "https://github.com/Vikramsolanki12",
  },
  {
    id: 6,
    title: "Ration Management System",
    date: "April 2025",
    description:
      "The Ration Management System is a mobile application developed using React Native for Android platforms. It is designed to streamline the distribution and tracking of ration supplies through a digital interface, targeting both end-users and ration dealers.This project demonstrates my ability to build scalable mobile solutions with local data handling, user-friendly UI/UX, and core features that cater to real-world needs like inventory, verification, and reporting.",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiXqNU_h0p3RK28PcaPjzKnXJOsrIewGLS4fKVroZzQvCGsfRpK82pro3IYGY_rdOLlQyn0nVaIlFyjRnKNjoEmHODQ-PJ2oo26xBCokmO2DBYLJ3FJy2IvEMrxT-fnbW1rL5VIxAE1phXQo-bY-VOdlEvPMDAE6h5bcFSNR-GbB2yOVJkLMx5QCLtrMbY/s320/ration_management.gif",
    tags: ["React Native", "JSX", "Local Storage", "React Navigation"],
    category: ["android app"],
    github: "https://github.com/Vikramsolanki12/Ration-Management-System.git",
  },
  {
    id: 7,
    title: "JK Pulse",
    date: "May 2025",
    description:
      "JK Pulse is a full-stack AI chatbot that combines an intuitive frontend with a powerful backend to deliver real-time conversational experiences using Google’s Gemini AI (Generative AI). Designed as a responsive and smart assistant, JK Pulse showcases seamless communication between client and server, secure API handling, and dynamic interaction via RESTful APIs.",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgQujJtc2mbsA_osF6fGEcIInzLYL8lz5t0jbafX8eHFQsxgnRbmkI3_AT2lJFXpDfCArNw6YeLzXxKydHF4q_t73-qp6YQhPnEu-FfjHaHfnau0-QoHxx_9E-FanqVvZ5SNqgWWJwP0qevYbjobRk7ilFzhBW0Z5v_cU2zXQIzZU_5HjTc6VM0tuQxI88/s320/Screenshot%202025-06-29%20at%2012.38.52%E2%80%AFAM.png",
    tags: ["React", "JavaSript", "Python", "Flask", "Rest API"],
    category: ["web app", "AI & ML"],
    github: "https://github.com/Vikramsolanki12/JK_Pulse.git",
    webapp: "https://github.com/Vikramsolanki12",
  },
  {
    id: 8,
    title: "JKonnect",
    date: "July 2025",
    description:
      " JKonnect is a modern, responsive task manager application built using React, designed to enhance productivity through an engaging and intelligent interface. It allows users to manage tasks efficiently while offering personalized features such as task rewards, category-based organization, and theme switching.",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiydliafG_sfnr5G2hW-rHqoa6aSKZdvKwWQtbQ0ZjaKta_jCE0wN-o9ZmwiNkulUFbZ8NMDsLzopVRELTjwtnmQb9ackUuNGmOeqI0onBYs2BX-W_AihjR5Lu7YqR4CFyTaAMO07Uiv8U4qx83RSz0o72xwYnTzJHtGLgY3IBchCr_NaLctToib1fQEMc/s320/task_manager.gif",
    tags: ["React Js", "Local Storage", "Redux"],
    category: ["web app"],
    github: "https://github.com/Vikramsolanki12/JKonnect.git",
    webapp: "http://jkonnect.vercel.app/",
  },

  {
    id: 9,
    title: "Neural Probabilistic Language Model (NPLM)",
    date: "July 2025",
    description:
      "This project implements a Neural Probabilistic Language Model (NPLM) inspired by Bengio et al. (2003), designed to predict the next word in a sentence based on a fixed-length context. Unlike traditional n-gram models that rely on word co-occurrence counts, this model uses learned word embeddings and a feedforward neural network to capture semantic relationships and improve generalization.",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEj6uyv5XXBEOjr8c312vzwLPUfS5GYlf7CAO5xKC_SzN8vZyV7s96vNIt5erx-4QrVUwMEdmvUyfKAqPQeGfgqUpU0DAO6dHhfmpq4rMwlylWj9vr2SCxj4dw20r_RUDeYpI4qAgFOl1RF9rXAQQY9oypDhBN6ODelctuYuROruM4HsmoUqIHO9CXQHdXo/s1600/images.png",
    tags: ["Python 3", "Machine Learning", "Deep Learning", "PyTorch", "NLP"],
    category: ["AI & ML"],
    github: "https://github.com/Vikramsolanki12/NPLMs.git",
  },
  {
    id: 10,
    title: "Robotic Dog",
    date: "July 2025",
    description:
      "Robotic Dog is a 15 cm tall quadruped robot designed to mimic the movement and behavior of a real dog. It is powered by MG90S servo motors controlled through an Arduino board and can walk, turn, and perform gestures with precise servo coordination. The robot integrates sensors for balance and obstacle detection, enabling semi-autonomous movement. This project explores robotic locomotion, servo kinematics, and control algorithms, serving as a foundation for advanced robotics applications in education and research.",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEje2E_CqnmY1grCIGYsfVodFh4jFMbxn8aYEr1jIvY81YFDi5nGDnmuQXn4GkinMfazwuwHvthJkaIIC0UG_gefcxfkLJnZFq5_NMPiQkBpVtDjYElU8wHP2OL3e-wwEnYrvZiU27YhFg55vKb16yc5boXLDjiCnjz89kTVn4hyqrDzMSXmi8tmLPR4aJ0/s320/IMG_20250627_174157.jpg",
    tags: ["Arduino", "Robotics", "Servo Motors", "Embedded Systems", "C++"],
    category: ["Robotics & IoT"],
    github: "https://github.com/Vikramsolanki12",
  },

  {
    id: 11,
    title: "TapShield – A Wearable SOS Device",
    date: "Aug 2025",
    description:
      "TapShield is a smart wearable SOS device designed to ensure personal safety through instant, gesture-based alerts. It uses an Arduino Nano, SIM800L GSM module, and a piezo sensor to detect unique tap patterns and send different emergency SMS messages. Integrated with TinyML, the device learns to recognize distinct tap patterns (e.g., single tap, double tap, or rapid taps) for customized responses, making it ideal for women, seniors, and field workers. This project combines embedded systems, IoT, and machine learning for real-time emergency assistance.",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiBi3MQxdFACvkKWgLEf4kVMW7YsSWc1jIrPLLEiqhb9Tbz5ofmaI6srjN0LqFOcNZq_QdI2AEolwIqnvyHzikJl623dwRlTIWYOPcZ1_sPQiK9-feiuwlcafxmhFO0SXPbhcrK7gy5WAi13rjwACFFXa_1x56mzxaGEmv3jA2lFqThnlzf-qIqsiEkavA/s320/prototype.png",
    tags: ["Arduino", "IoT", "TinyML", "Edge Impulse", "Embedded Systems"],
    category: ["Robotics & IoT"],
    github: "https://github.com/Vikramsolanki12/TapShield.git",
    webapp: "https://tapshield.vercel.app/",
  },

  {
    id: 12,
    title: "VendorVerse",
    date: "Aug 2025",
    description:
      "VendorVerse is a web-based supplier dashboard that allows vendors to create their stores, manage products, and handle inventory efficiently. Built with React.js for the frontend and Firebase for authentication, storage, and Firestore database, it provides seamless product management, secure image uploads, and real-time stock updates. The platform includes authentication flows for suppliers, a dynamic dashboard, and a responsive design optimized for desktop and mobile devices.",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhSvKE-dfauAoDoyc6KXDtFezt5NxkLwXN-_s_sWGkwGmF9vaAKDH8_cEDACsvCJk-WW_gs_bnpw2-U051NaNOfYiyg9h4g-BVulz0jnaTPtjrbUnc3SUheb_aB4EVCwOtk97RIfZrp5cR_eq_7b_sg3FlxE795aVUMsnDOm6Z1v_Eu2g_GDmYB9vMy5W8/s320/Screenshot%202025-10-19%20at%2011.50.21%E2%80%AFAM.png",
    tags: ["React.js", "Firebase", "Web Development", "JavaScript", "Frontend"],
    category: ["web app"],
    github: "https://github.com/Vikramsolanki12/VendorVerse.git",
    webapp: "https://vendorverse-eta.vercel.app/",
  },
  {
    id: 13,
    title: "Computer Vision based Autonomous Path Finder",
    date: "Aug 2025",
    description:
      "This project implements a computer vision-based autonomous pathfinding robot using ESP32-CAM. The robot captures live video streams and processes them with OpenCV to detect obstacles and navigate safely toward a predefined destination. Pathfinding is achieved using the A* algorithm, with the robot capable of receiving HTTP commands from a JavaScript frontend or running fully autonomously. The system integrates real-time video processing, obstacle avoidance, and grid-based navigation for precise movement.",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiez2jXWBPMvIdB40Vd0OrhDRoH93bdj7IzQXQdBx-gHAuALVYwZCfHurTUs65pcvmpaNoZM7RAPuhUeLjbMQ_0Y7rKz2fvDbPKE3cKeN2oL5d5nNqouQ_N046WE7nlCAH4FQ_k3XS2ASXR195_Pw2zhVfXKUHn09a1SUC8XmMKHoqQBTZtZBJW6slfTYI/s320/Screenshot%202025-10-19%20at%2012.16.42%E2%80%AFPM.png",
    tags: ["ESP32-CAM", "Computer Vision", "OpenCV", "Python", "Robotics"],
    category: ["Robotics & IoT"],
    github: "https://github.com/Vikramsolanki12/",
    webapp: "",
  },
];
